import _ from "lodash";
import { colors, responsiveFontSizes } from "@material-ui/core";
import { createTheme as createMuiTheme } from "@material-ui/core/styles";
import typography from "./typography";

const baseOptions = {
  typography,
  overrides: {
    MuiTableCell: {
      root: {
        borderBottom: "transparent",
      },
      head: {
        background: "#F4F7FF",
        // borderRadius: "10px",
      },
    },
    MuiTableRow: {
      root: {},
    },
    MuiFormLabel: {
      root: { color: "#222" },
      colorSecondary: {
        "&.Mui-focused": {
          color: "#222",
        },
      },
    },
    MuiListSubheader: {
      root: {
        color: "#000000",
        fontSize: "22px !important",
        fontWeight: "600 !important",
        lineHeight: "33px !important",
      },
    },
    MuiOutlinedInput: {
      root: {
        background: "#FCFCFC",
        borderRadius: "5px",
        height: "55px",
        // border: "1px solid rgba(0, 0, 0, 0.08)",
        "& .Mui-focused": {
          color: "#262626",
          border: "1px solid rgba(0, 0, 0, 0.08)",
        },
      },
      input: {
        color: "#000",
        fontSize: "14px",
        fontFamily:"poppins",
        fontWeight: 400,
      },
      notchedOutline: {
        borderColor: "rgba(0, 0, 0, 0.08)",
      },
      colorSecondary: {
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          color: "#262626",
        },
        "& .Mui-focused": {
          color: "#262626",
        },
      },
    },
    MuiPaper: {
      outlined: {
        padding: "20px",
        width: "100%",
      },
      elevation1: {
        background: "#fff",
        borderRadius: "10px",
        padding: "26px 20px",
        boxShadow: "none",
      },
      elevation2: {
        background:
          "linear-gradient(180deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0) 68.15%)",
        border: "2px solid rgba(0, 0, 0, 0.15)",
        borderRadius: "10px",
        padding: "20px",
        boxShadow: "none",
      },
    },
    MuiPopover: {
      root: {
        zIndex: 99999,
      },
    },
    MuiMenuItem: { root: { paddingLeft: "20px" } },
    MuiListItem: {
      root: {
        alignItems: "self-start",
      },
      gutters: {
        paddingLeft: 0,
      },
    },
    MuiCheckbox: {
      root: {
        padding: "6px",
        fontSize: "22px",
        color: "rgba(0, 0, 0, 0.40)",
        strokeWidth: "1.2px",
      },
      colorSecondary: {
        "&.Mui-checked": { color: "#FF7F26" },
      },
    },
    MuiFormControlLabel: {
      root: {
        paddingBottom: "0",
      },
    },
    MuiListItemSecondaryAction: {
      root: {
        right: 0,
      },
    },
    MuiDialog: {
      paperScrollPaper: {
        Width: 450,
        maxWidth: "100%",
      },
      paper: {
        overflowY: "scroll",
      },
      paperWidthSm: {
        maxWidth: "900px ",
      },
    },
    MuiInputBase: {
      input: {
        fontSize: 14,
        color: "#222",
        height: "0.1876em",
      },
    },
    MuiBackdrop: {
      root: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
    },
    MuiAutocomplete: {
      option: {
        fontFamily: "Poppins !important",
        fontSize: "12px !important",
        fontWeight: "400 !important",
        lineHeight: "18px !important",
        letterSpacing: "0px !important",
        textAlign: "left !important",
      },
    },
    MuiButton: {
      containedSecondary: {
        color: "#262626",
        height: "40px",
        padding: "10px 39px",
        fontSize: "14px",
        border: "1px solid #E1E1E1",
        background: "#E1E1E1",
        fontWeight: "400",
        lineHeight: "21px",
        fontFamily: "'Calibri', sans-serif",
        borderRadius: "5px",
        backgroundColor: "#E1E1E1",
        "&:hover": {
          background: "#E1E1E1",
          border: "1px solid #E1E1E1",
          boxShadow: "none !important",
          color: "#262626",
          backgroundColor: "#E1E1E1",
        },
      },

      containedPrimary: {
        color: "#fff",
        height: "40px",
        padding: "10px 39px",
        fontSize: "18px",
        background: "#EC1F24",
        border: "1px solid #EC1F24",
        fontWeight: "500",
        lineHeight: "21px",
        fontFamily: "'Calibri', sans-serif",
        borderRadius: "5px",
        backgroundColor: "#EC1F24",
        "&:hover": {
          color: "#fff",
          border: "1px solid #EC1F24",
          background: "#EC1F24",
        },
      },
      contained: {
        borderRadius: "50px",
        fontWeight: 600,
        padding: "5px 19px",
        boxShadow: "none !important",
      },
      outlinedPrimary: {
        color: "#EC1F24",
        border: "1px solid #EC1F24",
        padding: "5px 25px",
        fontWeight: "500",
        borderRadius: "50px",
        fontSize: "13px",
        "&:hover": {
          backgroundColor: "#EC1F24",
          border: "1px solid #EC1F24",
          color: "#fff",
        },
      },
      outlinedSizeSmall: {
        padding: "6px 23px",
        fontSize: "16px",
        lineHeight: " 24px",
      },
    },
    MuiDrawer: {
      paperAnchorDockedLeft: {
        borderRight: "0",
      },
    },
    MuiMenu: {
      paper: { top: "47px" },
    },

    MuiTypography: {
      subtitle1: {
        color: "#000",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: " 16px",
        colorSecondary: {
          color: "#8d8989",
        },
      },
    },
  },
};

const getThemesOptions = (isDarkMode = false) => {
  if (isDarkMode) {
    // Dark mode theme for Creator Mode
    return {
      typography: {
        fontWeight: 400,
        fontFamily: "'Poppins', sans-serif",
      },
      palette: {
        type: "dark",
        action: {
          primary: "#20509e",
        },
        background: {
          default: "#121212",
          dark: "#1e1e1e",
          paper: "#1e1e1e",
        },
        primary: {
          main: "#90caf9",
          dark: "#42a5f5",
          light: "#e3f2fd",
        },
        secondary: {
          main: "#fff",
        },
        warning: {
          main: "#ffae33",
          dark: "#ffae33",
          light: "#fff1dc",
        },
        success: {
          main: "#54e18c",
          dark: "#54e18c",
          light: "#e2faec",
        },
        error: {
          main: "#ED2124",
          dark: "#ff7d68",
          light: "#ffe9e6",
        },
        text: {
          primary: "#ffffff",
          secondary: "#FF7F26",
          light: "#b0b0b0",
          extralight: "rgba(255, 255, 255, 0.60)",
        },
        common: {
          black: "#000000",
        },
      },
    };
  }

  // Light mode theme (default)
  return {
    typography: {
      fontWeight: 400,
      fontFamily: "'Poppins', sans-serif",
    },
    palette: {
      type: "light",
      action: {
        primary: "#20509e",
      },
      background: {
        default: "#FBFBFD",
        dark: "#f3f7f9",
        paper: colors.common.white,
      },
      primary: {
        main: "#262A41",
        dark: "#de0d0d",
        light: "#de0d0d",
      },
      secondary: {
        main: "#fff",
      },
      warning: {
        main: "#ffae33",
        dark: "#ffae33",
        light: "#fff1dc",
      },
      success: {
        main: "#54e18c",
        dark: "#54e18c",
        light: "#e2faec",
      },
      error: {
        main: "#ED2124",
        dark: "#ff7d68",
        light: "#ffe9e6",
      },
      text: {
        primary: "#262626",
        secondary: "#FF7F26",
        light: "#484848",
        extralight: "rgba(0, 0, 0, 0.60)",
      },
      common: {
        black: "#000000",
      },
    },
  };
};

export const createTheme = (config = {}) => {
  const isDarkMode = config.isDarkMode || false;
  const themesOptions = getThemesOptions(isDarkMode);
  
  // Merge baseOptions with theme options
  let mergedOptions = _.merge({}, baseOptions, themesOptions);
  
  // Override specific styles for dark mode
  if (isDarkMode) {
    mergedOptions.overrides = {
      ...mergedOptions.overrides,
      MuiFormLabel: {
        root: { color: "#ffffff" },
        colorSecondary: {
          "&.Mui-focused": {
            color: "#ffffff",
          },
        },
      },
      MuiListSubheader: {
        root: {
          color: "#ffffff",
          fontSize: "22px !important",
          fontWeight: "600 !important",
          lineHeight: "33px !important",
        },
      },
      MuiOutlinedInput: {
        root: {
          background: "#1e1e1e",
          borderRadius: "5px",
          height: "55px",
          "& .Mui-focused": {
            color: "#ffffff",
            border: "1px solid rgba(255, 255, 255, 0.3)",
          },
        },
        input: {
          color: "#ffffff",
          fontSize: "14px",
          fontFamily: "poppins",
          fontWeight: 400,
        },
        notchedOutline: {
          borderColor: "rgba(255, 255, 255, 0.3)",
        },
      },
      MuiPaper: {
        outlined: {
          padding: "20px",
          width: "100%",
          backgroundColor: "#1e1e1e",
        },
        elevation1: {
          background: "#1e1e1e",
          borderRadius: "10px",
          padding: "26px 20px",
          boxShadow: "none",
        },
        elevation2: {
          background: "#1e1e1e",
          border: "2px solid rgba(255, 255, 255, 0.1)",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "none",
        },
      },
      MuiTypography: {
        subtitle1: {
          color: "#ffffff",
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: " 16px",
          colorSecondary: {
            color: "#b0b0b0",
          },
        },
      },
    };
  }
  
  let theme = createMuiTheme(mergedOptions);

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
